<template>
    <div
        class="filter__container"
        :class="{
            'filter__container--modal': hasModal,
            'filter__container--dropdown': !hasModal,
        }"
    >
        <template v-if="loading">
            <basic-loader :center="true" aria-label="FilterContainer" />
        </template>
        <template v-else>
            <div class="filter__info" v-if="hasModal">
                <div class="filter__info__title">
                    Recipients
                </div>
                <div class="filter__info__count">
                    <strong>{{ totalContactsToBroadcast || 0 }}&nbsp;</strong>
                    {{ totalContactsToBroadcast > 1 ? 'contacts' : 'contact' }} match

                    <fa-icon
                        v-if="this.isFirstFilterIntegration"
                        icon="exclamation-circle"
                        v-tooltip.top="`Up to ${ totalContactsToBroadcast || 0 } ${totalContactsToBroadcast > 1 ? 'contacts' : 'contact'}  will be enrolled in this Broadcast.`"
                    />
                </div>
            </div>

            <template v-if="disableScroll">
                <div class="filter__list">
                    <div
                        v-for="(filters, filtersIndex) in filtersList"
                        class="filter__listItem"
                    >
                        <div
                            v-if="filtersIndex > 0"
                            class="filter__listItem__separationOr"
                        >
                            OR
                        </div>

                        <div
                            v-bind::key="filtersIndex"
                            class="filter__items"
                        >
                            <template v-for="(filter, filterIndex) in filters">
                                <div
                                    v-if="filterIndex > 0"
                                    class="filter__item__separationAnd"
                                >
                                    and
                                </div>
                                <filter-item
                                    :dropdownClass="dropdownClass"
                                    :name="name"
                                    :filtersList="filtersList"
                                    :filtersData="filtersData"
                                    :filterIndex="filterIndex"
                                    :filtersIndex="filtersIndex"
                                    :filter="filter"
                                    :isFilterEmpty="isFilterEmpty"
                                    @removeFilter="removeFilter(filter.key, filters)"
                                    @changeValueFilter="changeValueFilter"
                                    @handleChangeLoadingSend="handleChangeLoadingSend"
                                    @toggleOperatorVisibility="toggleOperatorVisibility"
                                />
                            </template>
                            <div
                                v-if="isOperatorsVisible"
                                class="filter__bottom">
                                <div class="filter__left">
                                    <div
                                        class="button"
                                        @click="addFilter(filters)"
                                    >
                                        + AND
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div
                        v-if="isOperatorsVisible"
                        class="filter__bottom filter__bottom--or">
                        <div class="filter__left">
                            <div
                                class="button"
                                @click="addList()"
                            >
                                + OR
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="filter__list">
                    <vue-scroll :ops="ops" ref="vueScroll">
                        <div>
                            <div
                                v-for="(filters, filtersIndex) in filtersList"
                                class="filter__listItem"
                            >
                                <div
                                    v-if="filtersIndex > 0"
                                    class="filter__listItem__separationOr"
                                >
                                    OR
                                </div>

                                <div
                                    v-bind::key="filtersIndex"
                                    class="filter__items"
                                >
                                    <template v-for="(filter, filterIndex) in filters">
                                        <div
                                            v-if="filterIndex > 0"
                                            class="filter__item__separationAnd"
                                        >
                                            and
                                        </div>
                                        <filter-item
                                            :dropdownClass="dropdownClass"
                                            :filtersList="filtersList"
                                            :filtersData="filtersData"
                                            :filterIndex="filterIndex"
                                            :filtersIndex="filtersIndex"
                                            :disableSegment="disableSegment"
                                            :filter="filter"
                                            :isFilterEmpty="isFilterEmpty"
                                            :name="name"
                                            @removeFilter="removeFilter(filter.key, filters)"
                                            @changeValueFilter="changeValueFilter"
                                            @handleChangeLoadingSend="handleChangeLoadingSend"
                                            @toggleOperatorVisibility="toggleOperatorVisibility"
                                        />
                                    </template>
                                    <div
                                        v-if="isOperatorsVisible"
                                        class="filter__bottom">
                                        <div class="filter__left">
                                            <div
                                                class="button"
                                                @click="addFilter(filters)"
                                            >
                                                + AND
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div
                                v-if="isOperatorsVisible"
                                class="filter__bottom filter__bottom--or">
                                <div class="filter__left">
                                    <div
                                        class="button"
                                        @click="addList()"
                                    >
                                        + OR
                                    </div>
                                </div>
                            </div>
                        </div>
                    </vue-scroll>
                </div>
            </template>

            <template v-if="!hasModal">
                <template v-if="typeSegment === 'create'">
                    <div class="filter__buttons">
                        <div class="filter__buttons__left">
                            <button
                                class="button"
                                :class="{
                                    'is-disabled': disabledSaveSegment,
                                }"
                                v-if="disableSegment"
                                :disabled="disabledSaveSegment"
                                @click="handleOpenSaveSegmentModal"
                            >
                                Save Segment
                            </button>
                        </div>
                        <div class="filter__buttons__right">
                            <button
                                class="button"
                                @click="clear($event)"
                            >
                                Clear All
                            </button>
                            <button
                                class="button is-primary"
                                :class="{
                                    'is-loading': loadingSend,
                                    'is-disabled': disabled,
                                }"
                                :disabled="disabled"
                                @click="applyFilter"
                            >
                                Preview
                            </button>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="filter__buttons">
                        <div class="filter__buttons__left">
                            <button
                                class="button is-danger"
                                @click="handleOpenDeleteSegmentModal"
                            >
                                Delete
                            </button>
                        </div>
                        <div class="filter__buttons__right">
                            <button
                                class="button"
                                @click="closeFilter"
                            >
                                Cancel
                            </button>
                            <button
                                class="button is-primary"
                                :class="{
                                    'is-loading': loadingSend,
                                    'is-disabled': disabledSaveSegment,
                                }"
                                :disabled="disabledSaveSegment"
                                @click="handleOpenUpdateSegmentModal"
                            >
                                Update
                            </button>
                        </div>
                    </div>
                </template>
            </template>
        </template>
    </div>
</template>

<script>
import FilterItem from './FilterItem';

export default {
    emits: ['closed', 'changeValueFilter', 'clear', 'removeFilter', 'addFilter', 'addList', 'applyFilter', 'handleOpenSaveSegmentModal', 'handleChangeTypeSegment', 'handleChangeLoadingSend'],

    components: {
        FilterItem,
    },

    props: {
        dropdownClass: { type: String, default: '' },
        loading: { type: Boolean, default: false },
        filtersList: { type: Array },
        filtersData: { type: Object },
        loadingSend: { type: Boolean, default: false },
        isFilterEmpty: { type: Boolean, default: false },
        hasModal: { type: Boolean, default: false },
        disableScroll: { type: Boolean, default: false },
        form: { type: Object },
        chooseFilter: { type: Object },
        totalContactsToBroadcast: { type: Number },
        filterSelected: { type: Number },
        filtersValues: { type: Boolean, default: false },
        typeSegment: { type: String, default: 'create' },
        disableSegment: { type: Boolean, default: true },
        isFirstFilterIntegration: { type: Boolean, default: false },
        name: { type: String, default: '' },
    },

    data() {
        return {
            ops: {
                vuescroll: {
                    sizeStrategy: 'number',
                },
                scrollPanel: {
                    maxHeight: 500,
                },
                bar: {
                    showDelay: 500,
                    onlyShowBarOnScroll: true,
                    keepShow: true,
                    background: '#7a7a7a',
                    opacity: 1,
                    hoverStyle: false,
                    specifyBorderRadius: false,
                    minSize: 0,
                    size: '6px',
                    disable: false
                }
            },
            isOperatorsVisible: true,
            backdoor: 0,
        };
    },

    computed: {
        disabled() {
            return Boolean(this.loadingSend || !this.filterSelected || !this.filtersValues);
        },

        disabledSaveSegment() {
            // small hack for force Computed method
            // eslint-disable-next-line no-unused-expressions
            this.backdoor;
            let hasSegmentsOrIntegration = false;

            if (this.name === 'contacts') {
                this.filtersList.forEach(item => {
                    item.forEach(el => {
                        if (el.name === 'segments' || el.name === 'integrations') {
                            hasSegmentsOrIntegration = true;
                        }
                    });
                });
            }

            return Boolean(this.loadingSend || !this.filterSelected || !this.filtersValues) || hasSegmentsOrIntegration;
        }
    },

    methods: {
        toggleOperatorVisibility(status) {
            this.isOperatorsVisible = status;
        },

        closeFilter() {
            this.$emit('closed', false);
        },

        changeValueFilter(filter) {
            // small hack for force Computed method
            if (this.name === 'contacts') this.backdoor++;

            this.$emit('changeValueFilter', filter);
        },

        clear(e, status = true) {
            this.$emit('clear', {
                e: e,
                status: status,
            });
        },

        removeFilter(key, filters) {
            this.$emit('removeFilter', { key, filters });
        },

        addFilter(filters) {
            this.$emit('addFilter', { filters });
        },

        addList() {
            this.$emit('addList');
        },

        applyFilter() {
            if (this.disabled) return;

            this.$emit('applyFilter');
        },

        handleOpenSaveSegmentModal() {
            this.$emit('handleOpenSaveSegmentModal', true);
            this.$emit('handleChangeTypeSegment', 'create');
        },

        handleOpenUpdateSegmentModal() {
            this.$emit('handleOpenSaveSegmentModal', true);
            this.$emit('handleChangeTypeSegment', 'update');
        },

        handleOpenDeleteSegmentModal() {
            this.$emit('handleOpenSaveSegmentModal', true);
            this.$emit('handleChangeTypeSegment', 'delete');
        },

        handleChangeLoadingSend(status) {
            this.$emit('handleChangeLoadingSend', status);
        },
    },
};
</script>
